import { call, put, select, takeLatest } from 'redux-saga/effects';
import { billingClient } from '../../utils/axios';
import {
  fetchSubscriptionFailure,
  fetchSubscriptionRequest,
  fetchSubscriptionSuccess,
  fetchSubscriptionUsageFailure,
  fetchSubscriptionUsageRequest,
  fetchSubscriptionUsageSuccess,
} from './subscriptionSlice';

function* fetchSubscription() {
  try {
    const response = yield call(billingClient.get, '/subscriptions/current');
    yield put(fetchSubscriptionSuccess(response.data));
    yield put(fetchSubscriptionUsageRequest());
  } catch (error) {
    if (error.response?.status === 404) {
      yield put(fetchSubscriptionSuccess(null));

      return;
    }

    yield put(
      fetchSubscriptionFailure(
        error.response?.data?.errors?.message || error.message || 'Failed to fetch subscription',
      ),
    );
  }
}

function* fetchSubscriptionUsage(action) {
  try {
    const subscription = yield select((s) => s.subscription?.subscription);
    const subscriptionId = action.payload?.subscriptionId ?? subscription?.stripe_subscription_id;
    const periodStart = action.payload?.periodStart ?? subscription?.current_period_start;
    const periodEnd = action.payload?.periodEnd ?? subscription?.current_period_end;

    if (!subscriptionId || periodStart == null || periodEnd == null) {
      return;
    }

    const response = yield call(billingClient.get, `/subscriptions/${subscriptionId}/usage`, {
      params: {
        period_start: periodStart,
        period_end: periodEnd,
      },
    });
    yield put(fetchSubscriptionUsageSuccess(response.data));
  } catch (error) {
    yield put(
      fetchSubscriptionUsageFailure(
        error.response?.data?.errors?.message || error.message || 'Failed to fetch subscription usage',
      ),
    );
  }
}

export default function* subscriptionSaga() {
  yield takeLatest(fetchSubscriptionRequest.type, fetchSubscription);
  yield takeLatest(fetchSubscriptionUsageRequest.type, fetchSubscriptionUsage);
}
